<template>
  <core-view>
    <div id="app">
      <camera />
    </div>
  </core-view>
</template>

<script>
// import Buefy from 'buefy';
import Vue from 'vue';
import Camera from '@/views/camera/Camera.vue';
import CoreView from '@/components/core/view/Index.vue';

// import './registerServiceWorker';
// import 'buefy/dist/buefy.css';
import '@fortawesome/fontawesome-free/css/all.css';

export default {
  components: {
    CoreView,
    Camera,
  },
};

// Vue.use(Buefy);
Vue.config.productionTip = false;
</script>

<style >

</style>
